module.exports = __webpack_public_path__ + "static/media/chg11.b7ca4564.png";